import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { AiOutlineMenu } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { NavItems } from "./NavItems";

export default function UserSidebar() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(!show);

  return (
    <div className="user-sidebar-wrapper">
      <Button variant="topbar-icon" className="menu-btn" onClick={handleShow}>
        <AiOutlineMenu size={20} />
      </Button>
      <section className={"user-sidebar " + (show ? "mobile-sidebar" : null)}>
        <Button
          variant="topbar-icon"
          className="cross-btn"
          onClick={handleShow}
        >
          <FaTimes size={20} />
        </Button>
        <div className="container">
          <div className="row g-0">
            <div className="col-md-12">
              <div className="d-flex align-items-center mt-3 mb-4">
                <img className="logo" src={"/images/logo1.png"} alt=""></img>
                <h4 className="ms-3 primary-text">
                  Bubbles<br></br>& Smiles
                </h4>
              </div>
              <div className="main-menu d-flex flex-column ms-lg-2">
                <NavItems />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
